export default __webpack_public_path__ + "static/media/send-money.037d3448.svg";